export function nonNullable<T>(value: T): value is NonNullable<T> {
    return value !== null && value !== undefined
}

export function nonNullableEntry<T>(value: [string, T]): value is [string, NonNullable<T>] {
    return nonNullable(value[1])
}
